import React, { useEffect } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from 'react-router-dom';
import MasterBase from "../components/MasterLayout";
import { readonly } from '../modules/formstore';
import { isEmpty, getformid, getcontroller, getsubkey } from '../modules/appLibrary';

export const Section = props => {
    const dispatch = useDispatch();
    const formid = getformid("Section", props.location.search);
    const controller = getcontroller("Section", props.location.search);
    const subkey = getsubkey(props.location.search);
    const search = useLocation().search;

    const actionurl = {
        "insert": "section/Insert",
        "update": "section/Update",
        "delete": "section/Delete",
        "saveas": "section/SaveAs",
        "storageadd": "section/AddStorage",
        "storagerowdel": "section/StorageRowdel",
    }
    const navmenu = [
        { status: "VIEW", menuid: "excel", icon: "file_download", label: "Excel", title: "現在のシート内容をExcelに出力します" },
    ]

    return (
        <div>
            <MasterBase
                formid={formid}
                controller={controller}
                subkey={subkey}
                location={props.location}
                actionurl={actionurl}
                condition={false}
                navmenu={navmenu}
            />
        </div>
    );
};
